// extracted by mini-css-extract-plugin
module.exports = {"novaTarefa":"Formulario_novaTarefa__Dzuia","inputContainer":"Formulario_inputContainer__3Y4tm"};